export const BackEnd = {
  baseUrl: '',
  bearerToken: ''
}
